import React from 'react'
import DoneIcon from '@material-ui/icons/Done'
import clsx from 'clsx'

import './GroupBy.scss'

const GroupBy = ({show, onChange = (e, v) => {}, value = null, options = []}) => {
  return (
    <div
      style={{position: 'absolute', left: 190}}
      hidden={!show}
      className="m-sorting-modal ap-pop-options c-group-by"
    >
      <div className="ap-pop-options__scroll-wrapper ap-scrollbar">
        <div
          className={clsx(
            'res-mod ap-pop-options__item c-group-by__item',
            value === null ? 'c-group-by__item--selected' : ''
          )}
          onClick={e => onChange(e, null)}
        >
          <DoneIcon />
          <span style={{flex: 1, marginLeft: 8}}>None</span>
        </div>

        {options.map(o => (
          <div
            key={o.field_id}
            className={clsx(
              'res-mod ap-pop-options__item c-group-by__item',
              value?.field_id === o.field_id ? 'c-group-by__item--selected' : ''
            )}
            onClick={e => onChange(e, o)}
          >
            <DoneIcon />
            <span style={{flex: 1, marginLeft: 8}}>{o.field_name}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default GroupBy
